var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-btn"},[_c('a',{attrs:{"href":"#up"}},[_c('div',{staticClass:"flecha-btn"})])])
}]

export { render, staticRenderFns }